"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const styles = ({ palette, shape, components }) => ({
    sidewayTooltipWrapper: {
        minWidth: 120,
        display: 'grid',
        gridColumnGap: 10,
        color: palette.text.primary,
        borderRadius: shape.borderRadius,
        padding: shape.padding[2],
    },
    sidewayTooltipBullet: {
        maxWidth: 15,
        width: 12,
        height: 12,
        borderRadius: '50%',
        marginTop: 6,
        gridRowStart: 1,
        gridColumnStart: 1,
    },
    sideWayTooltipPara: {
        margin: 0,
        padding: 0,
        gridColumnStart: 2,
        gridRowStart: 1,
    },
    gridRowSecond: {
        gridRowStart: 2,
    },
    barChartTooltipWrapper: {
        color: palette.text.secondary,
        borderRadius: shape.borderRadius * 2,
        padding: shape.padding[2],
        textAlign: 'left',
    },
    barChartTooltipDate: {
        color: 'inherit',
        backgroundColor: 'transparent',
        fontSize: 12,
    },
    barChartTooltipDateMargin: {
        marginBottom: 5,
    },
    barChartTooltopLineSeparator: {
        width: '100%',
        height: 2,
        borderBottomStyle: 'solid',
        borderBottomColor: palette.grey.level3,
        margin: '5px 0px',
    },
    barChartTooltopLineSeparatorBorderWidth: {
        borderBottomWidth: 1,
    },
    barChartTooltopLineSeparatorBorderWidthZero: {
        borderBottomWidth: 0,
    },
    barChartTooltipTotal: {
        fontSize: 14,
        backgroundColor: 'transparent',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        color: components.tooltip.primaryTextColor,
    },
});
exports.default = styles;
